import React from 'react';
var ConfigContext = React.createContext({});
ConfigContext.displayName = 'UseAPIConfigContext';
export default ConfigContext;